import { LoginAPI } from '@/api'

import { useAPIMutation } from '../useAPI'

export function useLogout() {
  return useAPIMutation<LoginAPI.REFRESH.Body, LoginAPI.REFRESH.Response>({ url: '/rusty/logout', method: 'post' })
}
